app.controller('DataApiCategoryController', ['$rootScope', '$scope', '$state', '$stateParams', function ($rootScope, $scope, $state, $stateParams) {

    const dataApiID = $scope.data_api_id ? $scope.data_api_id : ($state.$current && $state.$current.data ? $state.$current.data.data_api_id : null);
    const categorySlug = $scope.category_slug ? $scope.category_slug : $stateParams.category_slug;
    let selectedChildCategorySlug = $stateParams.child_category_slug ? $stateParams.child_category_slug : "";
    $scope.category_slug = categorySlug;

    const dataApiService = $rootScope.service.data_api;

    const data_api_model = dataApiService.factory.getModel({data_api_id: dataApiID});


    const defaultCategoryTitle = "View All";

    let selectedGrandChildCategorySlug = 0;

    $scope.category = null;

    $scope.category_drop_down_text = defaultCategoryTitle;
    $scope.subcategory_drop_down_text = defaultCategoryTitle;


    $scope.selectChildCategory = function (slug) {

        const category = $scope.category;
        if (category && category.child_categories[slug]) {
            selectedChildCategorySlug = slug;
            $scope.category_drop_down_text = category.child_categories[slug].name;
        } else {
            selectedChildCategorySlug = null;
            $scope.category_drop_down_text = defaultCategoryTitle;
        }
        selectedGrandChildCategorySlug = null;
        $scope.subcategory_drop_down_text = defaultCategoryTitle;
        $scope.selected_child_category_slug = selectedChildCategorySlug;

    }

    $scope.checkChildCategory = () => {
        const stateSlug = $stateParams.child_category_slug ? $stateParams.child_category_slug : "";
        const currentSlug = selectedChildCategorySlug ? selectedChildCategorySlug : "";
        if(currentSlug !== stateSlug){
            $scope.selectChildCategory(stateSlug);
        }
    }

    if (categorySlug) {
        data_api_model.requireCategoryPostList(categorySlug, function () {
            $scope.category = data_api_model.categories[categorySlug];

            if(selectedChildCategorySlug){
                $scope.selectChildCategory(selectedChildCategorySlug);
            }
        });
    }

    $scope.selectedChildCategory = function () {
        if (!selectedChildCategorySlug) {
            return null;
        }
        const category = $scope.category;
        return category && category.child_categories[selectedChildCategorySlug] ? category.child_categories[selectedChildCategorySlug] : null;
    }

    $scope.selectGrandChildCategory = function (slug) {
        const childCategory = $scope.selectedChildCategory();
        if (childCategory && childCategory.child_categories[slug]) {
            selectedGrandChildCategorySlug = slug;
            $scope.subcategory_drop_down_text = childCategory.child_categories[slug].name;
        } else {
            selectedGrandChildCategorySlug = null;
            $scope.subcategory_drop_down_text = defaultCategoryTitle;
        }
    }


    $scope.selectedGrandChildCategory = function () {
        if (!selectedGrandChildCategorySlug) {
            return null;
        }
        const childCategory = $scope.selectedChildCategory();
        return childCategory && childCategory.child_categories[selectedGrandChildCategorySlug] ? childCategory.child_categories[selectedGrandChildCategorySlug] : null;
    }


}]);